import { render } from "./Document.vue?vue&type=template&id=16781bd6&scoped=true&ts=true"
import script from "./Document.ts?vue&type=script&lang=ts"
export * from "./Document.ts?vue&type=script&lang=ts"

import "./Document.scss?vue&type=style&index=0&id=16781bd6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16781bd6"]])

export default __exports__